export default "__VITE_ASSET__CdR60XeR__"